export {default as salesPerformance} from './salesPerformance'
export {default as occupancy} from './occupancy'
export {default as dashboard} from './dashboard'
export {default as softAndHardBlackouts} from './softAndHardBlackouts'